/**
 * Registers event handlers for the Journey Panel on the Home Page.
 * 
 */
define([
    'jquery',
    'shared/scripts/pages/enrolment-commons'
    ],

    function ($, enrolmentCommons) {
	
    'use strict';

    var config = {
        journeyPanelJoinBtnId: 'journey-join-transfer-button',
		journeyPanelAddDepBtnId: 'journey-add-dependant-button',
        intlJoinTodayBtn1Id: 'international-join-today-button-1',
        intlJoinTodayBtn2Id: 'international-join-today-button-2'
    };
    
    
    /**
     * Handler for the Button click events on the "Yes/No" buttons.
     */
    function registerBtnClickHandlers(isCustomEnrolmentFlag, schemeNo, vhiContactList) {


        // Temp for covid-19
        //$('#'+config.journeyPanelAddDepBtnId).on('click', handleButtonClickEvent(vhiContactList));

    	//override default flow only if Custom Enrolment has been enabled.
    	if(isCustomEnrolmentFlag){
            var isContentAvailablePromise = isEnrolmentContentAvailable(schemeNo);
            isContentAvailablePromise.done(function () {
                $('#'+config.journeyPanelJoinBtnId).on('click', handleButtonClickEvent(schemeNo));
                $('#'+config.journeyPanelAddDepBtnId).on('click', handleButtonClickEvent(schemeNo));
                $('#'+config.intlJoinTodayBtn1Id + ', #'+config.intlJoinTodayBtn2Id).on('click', handleButtonClickEvent(schemeNo));
            });
            return isContentAvailablePromise;
    	} else {
    		return $.Deferred().reject(false);
		}
/* LEFT COMMENTED OUT IN CASE RERATE RELATED POP-UP NEEDS TO BE TURNED ON QUICKLY
    	function handleAddDependentButtonClickEvent(vhiContactList) {
    	    return function (eventObj) {
                // Display covid-19 explainer popup
                eventObj.preventDefault();

                var $this = $(eventObj.currentTarget);

                var transactionType = $this.attr('data-journey-type');
                var href = '/groups';

                var contactNumber = vhiContactList[0].contactNumber;
                $('#rerate-contact-number').html(contactNumber);

                var closeButton = $('#rerate-time');
                closeButton.attr('href', href);
                closeButton.attr('data-journey-type', transactionType);

                var modalPanel = $('#rerate-modal');
                modalPanel.localize({"context" : transactionType});
                modalPanel.modal('show');
            };
        }
*/
        /**
         * Helper function.
         */
        function handleButtonClickEvent(schemeNo) {
            return function (eventObj) {
                eventObj.preventDefault();
                var clickedButtonId = eventObj.target.id;
                var navigationTarget = null;
                var targetRoot = 'groups';
                if(clickedButtonId===config.journeyPanelJoinBtnId) {
                    navigationTarget = "join-details-start";
                }
                else if(clickedButtonId===config.journeyPanelAddDepBtnId) {
                    navigationTarget = "add-dependant";
                }
                else if(clickedButtonId === config.intlJoinTodayBtn1Id || clickedButtonId === config.intlJoinTodayBtn2Id) {
                    navigationTarget = "join-details-start";
                    targetRoot = 'intgroups';
                }

                var enrolmentConfig = enrolmentCommons.getConfig(targetRoot, navigationTarget);
                enrolmentCommons.updateEnrolmentContent(schemeNo, enrolmentConfig);
            };
        }
    }
    
    
    function registerEventListeners(isCustomEnrolmentFlag, schemeNo, vhiContactList){
    	console.log('Registering Journey Panel event listeners');
    	return registerBtnClickHandlers(isCustomEnrolmentFlag, schemeNo, vhiContactList);
    }
    
    function isEnrolmentContentAvailable(schemeNo){
    	var customEnrolmentContentUrl = '/online-services/enrolment-content/' + schemeNo + '/groups';

        return $.ajax({
            type: 'GET',
            url: customEnrolmentContentUrl,
            async: true,
            dataType: 'json'
        }).then(function (data) {
            return true;
        }, function (error) {
            return false;
        });
    }

    
    /**
     * Expose API to caller.
     * 
     */
    return {
    	registerEventListeners: registerEventListeners
    };
    
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/journeyPanelDynamicBehaviour.js
// module id = GjX5
// module chunks = 14